import { onScopeDispose } from 'vue';

const HOLD_DELAY_MS = 300;
const HOLD_REPEAT_MS = 50;

/** 버튼 꾹 누름 시 연속 증감 (레거시 임금대장 시급 스피너) */
export function useHoldRepeat(onStep: () => void) {
  let delayTimer: ReturnType<typeof setTimeout> | null = null;
  let repeatTimer: ReturnType<typeof setInterval> | null = null;

  const stop = () => {
    if (delayTimer != null) {
      clearTimeout(delayTimer);
      delayTimer = null;
    }
    if (repeatTimer != null) {
      clearInterval(repeatTimer);
      repeatTimer = null;
    }
    window.removeEventListener('pointerup', stop);
    window.removeEventListener('pointercancel', stop);
    document.removeEventListener('blur', stop);
  };

  const start = () => {
    stop();
    onStep();
    window.addEventListener('pointerup', stop);
    window.addEventListener('pointercancel', stop);
    document.addEventListener('blur', stop);
    delayTimer = setTimeout(() => {
      repeatTimer = setInterval(onStep, HOLD_REPEAT_MS);
    }, HOLD_DELAY_MS);
  };

  onScopeDispose(stop);

  return { start, stop };
}
